import { MODULE_CATALOGUE } from '@his/shared';

export interface Branch {
  id: string;
  code: string;
  name: string;
  city: string | null;
  phone: string | null;
  address?: string | null;
  country?: string | null;
  currency?: string | null;
  taxConfigured?: boolean;
  isActive: boolean;
  parentBranchId?: string | null;
  categoryModules?: string[];
  approvalStatus?: 'pending' | 'approved' | 'rejected';
  rejectionReason?: string | null;
  rejectedAt?: string | null;
  approvedAt?: string | null;
  letterheadLine?: string | null;
  subdivision?: string | null;
  nameLocal?: string | null;
  addressLocal?: string | null;
  _count: { departments: number; users: number };
}

export interface Store {
  id: string;
  branchId: string;
  code: string;
  name: string;
  type: string;
  isSellingPoint: boolean;
  isActive: boolean;
  ward: { id: string; name: string } | null;
}

export interface Department {
  id: string;
  branchId: string;
  code: string;
  name: string;
  kind: string;
  isActive: boolean;
}

export interface Specialty {
  id: string;
  code: string;
  name: string;
  nphiesPracticeCode: string | null;
  isActive: boolean;
}

export const STORE_TYPES = ['main_pharmacy', 'er_pharmacy', 'ot_pharmacy', 'ward_satellite', 'general_store'];

export const DEPARTMENT_KINDS = ['clinical', 'diagnostic', 'pharmacy', 'support', 'administrative'];

export function moduleName(code: string): string {
  return MODULE_CATALOGUE.find((module) => module.code === code)?.name ?? code;
}

export const ORG_TAB_IDS = ['branches', 'departments', 'specialties', 'wards', 'stores'] as const;

export type OrgTabId = (typeof ORG_TAB_IDS)[number];

export function orgTabOf(value: string | null): OrgTabId {
  return ORG_TAB_IDS.includes(value as OrgTabId) ? (value as OrgTabId) : 'branches';
}

export function orgReturnTo(tab: OrgTabId): string {
  return tab === 'branches' ? '/admin/branches' : `/admin/branches?tab=${tab}`;
}
